export const setCookiePolicyToStorage = () => {
  localStorage.setItem('cookiePolicy', 'agreed');
};
